export default "__VITE_ASSET__82b6b001__"